import type { InvariantJiraRoute } from '@atlassian/jira-route-types/src/InvariantJiraRoute.tsx';

export const helpCenterSettingsSupportWebsiteRoute: InvariantJiraRoute = {
	name: 'helpcenter-settings-support-website-details',
	path: '/jira/helpcenter/projects/:projectKey/settings/:helpCenterId/support-website',
	exact: true,
};
